import {
  VSpacer
} from 'vuetify/lib'

export default function (h) {
  return h(
    'div',
    {
      style: this.internalImageData ? {
        width: '100%',
        height: '100%'
      } : undefined
    },
    [
      h('div', {
        style: {
          textAlign: 'center',
          wordBreak: 'break-all'
        }
      }),
      h(
        'div',
        {
          style: {
            display: ['-ms-inline-grid', 'inline-grid'],
            gridColumns: '1fr auto',
            gridRows: '1fr auto',
            gridTemplateColumns: '1fr auto',
            gridTemplateRows: '1fr auto',
            ...(this.fullHeight ? { height: '100%' } : {}),
            ...(this.fullWidth ? { width: '100%' } : {})
          }
        },
        [
          h(
            'div',
            {
              style: {
                gridColumn: 1,
                gridRow: 1,
                overflow: 'hidden',
                position: 'relative'
              }
            },
            [
              h(
                'div',
                {
                  ref: 'toBindForPanEndEvent',
                  style: {
                    alignItems: 'center',
                    background: this.checkeredBackground,
                    display: 'flex',
                    height: '100%',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    padding: `calc(${this.overlayPadding} + ${this.overlayBorderWidth})`,
                    position: 'relative',
                    width: '100%',
                    zIndex: 0,
                    ...(this.internalImageData || this.readonly
                      ? {}
                      : {
                        opacity: 0,
                        pointerEvents: 'none',
                        visibility: 'hidden'
                      }
                    )
                  },
                  ...(this.internalImageData
                    ? (this.disabled || this.readonly
                      ? {}
                      : { directives: [{
                        name: 'Claw',
                        arg: 'pan',
                        value: this.onPan
                      }] }
                    )
                    : {}
                  )
                },
                [h(
                  'div',
                  {
                    style: {
                      boxShadow: `0 0 4000px 4000px ${this.overlayBackgroundColor}`,
                      maxHeight: '100%',
                      maxWidth: '100%',
                      outline: `${this.overlayBorderWidth} solid ${this.overlayBorderColor}`,
                      pointerEvents: 'none'
                    }
                  },
                  [h(
                    'div',
                    {
                      style: {
                        height: `${this.imageHeight}px`,
                        position: 'relative',
                        width: `${this.$imageWidth}px`,
                        zIndex: -1,
                        ...(this.backgroundColor
                          ? { backgroundColor: this.backgroundColor }
                          : {}
                        )
                      }
                    },
                    [
                      ...(this.internalImageData
                        ? [h(
                          'img',
                          {
                            style: {
                              pointerEvents: 'none',
                              position: 'absolute',
                              transform: [
                                `translate(${this.croppingLeft}px,${this.croppingTop}px)`,
                                `scale(${this.scaling})`,
                                ...(this.rotated ? [`translateX(${this.internalImageHeight}px)`, 'rotate(90deg)'] : []),
                                ...(this.flippedVertically ? [`translateY(${this.internalImageHeight}px)`, 'scaleY(-1)'] : []),
                                ...(this.flippedHorizontally ? [`translateX(${this.internalImageWidth}px)`, 'scaleX(-1)'] : [])
                              ].join(' '),
                              transformOrigin: '0 0'
                            },
                            attrs: {
                              src: this.internalImageData
                            }
                          }
                        )]
                        : []
                      ),
                      ...(this.internalImageData && this.imageData
                        ? [h(
                          'input',
                          {
                            attrs: {
                              name: this.name,
                              type: 'hidden',
                              value: this.imageData
                            }
                          }
                        )]
                        : []
                      )
                    ]
                  )]
                )]
              ),
              ...(this.internalImageData || this.readonly
                ? []
                : [h(
                  'MyUploader',
                  {
                    props: {
                      disabled: this.disabled,
                      uploadIcon: this.uploadIcon,
                      uploadIconStyle: this.uploadIconStyle,
                      autoclick: this.autoclick,
                      label: this.label
                    },
                    style: {
                      bottom: 0,
                      left: 0,
                      position: 'absolute',
                      right: 0,
                      top: 0
                    },
                    on: {
                      load: this.load
                    }
                  }
                )]
              )
            ]
          ),
          h(
            'div',
            {
              style: {
                gridColumn: 1,
                gridRow: 2,
                ...(this.internalImageData
                  ? {}
                  : {
                    opacity: 0,
                    pointerEvents: 'none',
                    visibility: 'hidden'
                  }
                )
              }
            },
            (this.hideActions || this.readonly
              ? []
              : [h('MyScalingSlider')]
            )
          ),
          h(
            'div',
            {
              style: {
                display: 'flex',
                gridColumn: 1,
                gridRow: 3,
                justifyContent: 'center',
                ...(this.internalImageData
                  ? {}
                  : {
                    opacity: 0,
                    pointerEvents: 'none',
                    display: 'none'
                  }
                )
              }
            },
            [
              ...(this.hideActions || this.readonly
                ? []
                : [
                  h('MyRotateClockwiseButton'),
                  h('MyRotateCounterclockwiseButton'),
                  h('MyFlipHorizontallyButton'),
                  h('MyFlipVerticallyButton')
                ]
              ),
              ...(this.clearable
                ? [
                  h(VSpacer),
                  h('MyClearButton')
                ]
                : []
              ),
            ]
          )
        ])
    ]
  )
}
